import { Button, Divider } from '@heroui/react';
import React from 'react';

import { UserFormUser } from '../hooks/useProfilePicture';

interface AdminActionsSectionProps {
  user?: UserFormUser | null;
  isEditMode?: boolean;
  onSignInAsUser?: () => void;
}

export const AdminActionsSection: React.FC<AdminActionsSectionProps> = ({
  user,
  isEditMode = false,
  onSignInAsUser,
}) => {
  if (!isEditMode || !user || !onSignInAsUser) {
    return null;
  }

  return (
    <>
      <Divider />
      <div>
        <h3 className="text-lg font-medium text-foreground mb-4">
          Admin Actions
        </h3>
        <Button
          variant="bordered"
          color="primary"
          onPress={onSignInAsUser}
          className="w-full sm:w-auto"
        >
          Sign in as {user.name || 'this user'}
        </Button>
        <p className="text-default-500 text-sm mt-2">
          This will log you in as this user for testing purposes.
        </p>
      </div>
    </>
  );
};
